<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container dashboard-height">
    <ngb-alert
      *ngIf="optInAlert"
      class="sticky-top my-3"
      (closed)="closeOptInAlert()"
      style="top: 10px"
      [type]="optInAlert.type"
    >
      {{ optInAlert.message }}
    </ngb-alert>

    <div *ngIf="showDashboardInfoBox" class="dashboard-info-box d-flex align-items-center justify-content-center p-3 my-3 rounded">
      <p class="dashboard-info-text m-0" [innerHTML]="dashboardInfoBoxText"></p>
    </div>

    <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>

    <div *ngIf="areTheInitialRegistrationStepsIncomplete()" class="row progress-buttons-wrapper">
      <div class="user-progress-detail-wrapper col-3">
        <div class="me-1">
          <div class="user-progress-detail-label mb-1">Keeper details</div>
          <button
            type="button"
            [disabled]="isFullNameRegistrationCompleted"
            class="btn btn-identialert-color w-100 user-progress-detail-button"
            [ngClass]="isFullNameRegistrationCompleted ? 'registration-step-completed' : ''"
            [routerLink]="['/account/owner-details']"
          >
            {{ isFullNameRegistrationCompleted ? 'Done' : 'Not complete' }}
          </button>
        </div>
      </div>
      <div *ngIf="isFullNameRegistrationCompleted" class="user-progress-detail-wrapper col-3">
        <div class="me-1">
          <div class="user-progress-detail-label mb-1">Pet's details</div>
          <button
            type="button"
            [disabled]="!isFullNameRegistrationCompleted || isPetChipNumberRegistrationCompleted"
            class="btn btn-identialert-color w-100 user-progress-detail-button"
            [ngClass]="isPetChipNumberRegistrationCompleted ? 'registration-step-completed' : ''"
            (click)="navigateToClaimPetOrEditPet()"
          >
            {{ isPetChipNumberRegistrationCompleted ? 'Done' : 'Not complete' }}
          </button>
        </div>
      </div>
      <div
        *ngIf="isFullNameRegistrationCompleted && isPetChipNumberRegistrationCompleted && isMembershipSelectionStepAvailable"
        class="user-progress-detail-wrapper col-3"
      >
        <div class="me-1">
          <div class="user-progress-detail-label mb-1">Membership selection</div>
          <button
            type="button"
            [disabled]="
              !isFullNameRegistrationCompleted ||
              !isPetChipNumberRegistrationCompleted ||
              isMembershipSelectionCompleted
            "
            class="btn btn-identialert-color w-100 user-progress-detail-button"
            [ngClass]="isMembershipSelectionCompleted ? 'registration-step-completed' : ''"
            [routerLink]="['/account/membership-options']"
          >
            {{ isMembershipSelectionCompleted ? 'Done' : 'Not complete' }}
          </button>
        </div>
      </div>
      <ng-container *appFeatureFlag="'isPetPlanFreeInsuranceStep4Available'">
        <div
          *ngIf="
            isFullNameRegistrationCompleted &&
            isPetChipNumberRegistrationCompleted &&
            isMembershipSelectionCompleted &&
            isWelcomeGiftStepAvailable
          "
          class="user-progress-detail-wrapper col-3"
        >
          <div class="me-1">
            <div class="user-progress-detail-label mb-1">Free Petplan Insurance</div>
            <button
              type="button"
              [disabled]="
                !isFullNameRegistrationCompleted ||
                !isPetChipNumberRegistrationCompleted ||
                !isMembershipSelectionCompleted ||
                isWelcomePackSelectCompleted
              "
              class="btn btn-identialert-color w-100 user-progress-detail-button"
              [ngClass]="isWelcomePackSelectCompleted ? 'registration-step-completed' : ''"
              [routerLink]="['/welcome-gift']"
            >
              {{ isWelcomePackSelectCompleted ? 'Done' : 'Not complete' }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div [ngClass]="isMembershipSelectionCompleted || !isMembershipSelectionStepAvailable ? '' : 'blur-content'">
      <div class="row pt-4">
        <div [ngClass]="isDeviceTypeMobile ? 'col-lg-10' : 'col-lg-8'" class="col-md-12 col-sm-12">
          <div *ngIf="showDashboardWelcomeMessage" class="mb-2"><h5 [ngClass]="{'page-title': useRebrandedLayout }">Welcome to your dashboard</h5></div>
          <h1 class="d-flex flex-row justify-content-start flex-wrap align-items-center">
            <span class="fw-light text-primary w-100">Hi, {{ user.name.firstName }}</span>
            <span class="ms-0 badges">
              <span
                *ngIf="user.originalProductType === productType.Premium"
                class="badge custom-badge"
              >
                <h5 class="fw-bold text-primary mb-0">{{ plan2Name }}</h5>
              </span>
              <button
                *ngIf="userService.isUserBasic(user.originalProductType)"
                routerLink="/account/account-type"
                class="badge bg-primary btn btn-primary me-2"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
              >
                Basic
              </button>
              <button
                *ngIf="user.originalProductType === productType.BasicPlus"
                routerLink="/account/account-type"
                class="badge bg-secondary btn btn-secondary text-white me-2"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
              >
                {{ plan1Name }}
              </button>
              <button
                *ngIf="user.originalProductType === productType.LegacyPremium"
                class="badge bg-primary"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
              >
                Premium
              </button>
              <button
                *ngIf="user.originalProductType === productType.LegacyPlus"
                routerLink="/account/account-type"
                class="badge bg-primary btn btn-primary me-2"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
              >
                Plus
              </button>
              <span
                *ngIf="user.originalProductType === productType.Locator"
                class="badge bg-primary btn btn-primary me-2 badge--non-interactive"
              >
                {{ plan3Name }}
              </span>
              <button
                [routerLink]="['/my-pets']"
                class="badge bg-primary btn btn-primary me-2"
                trackClickEvent
                [eventNumber]="ClickEventNumbersEnum.PetDetails"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
              >
                My pets
              </button>
              <ng-container *appFeatureFlag="'isPetClaimAvailable'">
                <button
                  *appFeatureFlag="'isAddPetFlowEnabled'"
                  [routerLink]="['/claim-pet']"
                  [queryParams]="addPetQueryParams"
                  class="badge bg-primary btn btn-primary me-2"
                  [disabled]="areTheInitialRegistrationStepsIncomplete()"
                >
                  Add new pet
                </button>
              </ng-container>
              <ng-container *appFeatureFlag="'isPerkListAvailable'">
                <button
                  *ngIf="perks.length"
                  class="badge bg-primary btn btn-primary me-2"
                  [disabled]="areTheInitialRegistrationStepsIncomplete()"
                  (click)="scrollToOffers()"
                >
                  See your offers and perks
                </button>
              </ng-container>
            </span>
            <mat-chip-set aria-label="Dog selection" *ngIf="alivePets.length > 0" class="mat-chip-avatar">
              <mat-chip *ngFor="let pet of alivePets" [routerLink]="navigateToPetDetailPage(pet.id)">
                <div
                  *ngIf="pet.isTokPaymentRequired"
                  class="mat-chip-avatar-orange"
                  matChipAvatar
                ></div>
                <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-icon" matChipAvatar>
                  ❕
                </div>
                <img matChipAvatar [src]="getPetImageUrl(pet.imageId)" alt="Photo of the pet" />
                {{ pet.name }}
              </mat-chip>
            </mat-chip-set>
          </h1>

          <h3 [ngClass]="{'page-title my-3': useRebrandedLayout }">
            {{ welcomeMessage }}
          </h3>
          <ngb-alert
            *ngIf="showDashboardTopInfoMessage && isUserBasic"
            [dismissible]="false"
            type="info"
            class="my-3"
          >
            <div class="row">
              <div class="col-12">
                <span>You're on the <b>Basic</b> plan -</span>
                <span class="basic-info-top-text"> unlock more protection for {{petListString}}.</span>
              </div>
            </div>
          </ngb-alert>
        </div>
      </div>

      <div *ngIf="useRebrandedLayout; else legacyPricingTable">
        <div class="upgrade-plan-panel">
          <div class="d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4" *ngIf="!hasLocatorSubscription">
            <div class="d-flex gap-3">
              <span class="upgrade-plan-panel__icon d-flex align-items-center justify-content-center rounded-circle">
                <img src="/assets/images/icons/shield-plus.svg" width="22" height="22" alt="Shield with a plus icon" />
              </span>
              <div>
                <h2 class="upgrade-plan-panel__title fs-4 mb-2">{{ upgradePlanTitle }}</h2>
                <p class="upgrade-plan-panel__subtitle mb-0">{{ upgradePlanSubtitle }}</p>
              </div>
            </div>
            <div class="d-flex gap-2">
              <span class="upgrade-plan-panel__pill rounded-pill py-1 px-3">{{ visiblePlanCount }} plan{{ visiblePlanCount === 1 ? '' : 's' }}</span>
              <span class="upgrade-plan-panel__pill rounded-pill py-1 px-3">Yearly billing</span>
            </div>
          </div>

          <div class="row row-cols-1 row-cols-lg-3 g-4 mb-4 justify-content-center">
            <!-- Physical Smart Tag -->
            <app-plan-card
              *ngIf="hasLocatorSubscription"
              class="col col-lg-5"
              variant="locator"
              [showStripe]="false"
              [title]="page.locatorPlan.title"
              [subtitle]="smartTagPrice"
              [iconSrc]="page.locatorPlan.iconSrc"
              [colorOptions]="page.locatorPlan.colorOptions"
              [iconInHeader]="true"
              [infoLine]="page.locatorPlan.infoLine"
              ctaText="Lost your tag? Order a replacement"
              secondaryCtaText="Learn more"
              (selectPlan)="requestSmartTags()"
              (secondaryAction)="navigateToProductPage(PricingTableSubTypes.SMARTTAG)"
            ></app-plan-card>

            <ng-container *ngIf="!hasLocatorSubscription">
              <!-- Base+ -->
              <app-plan-card
                *ngIf="identibasePlusAvailable"
                class="col order-3 order-lg-1"
                variant="base"
                [showStripe]="false"
                [title]="page.basePlan.title"
                [price]="plan1YearlyPrice"
                [badgeText]="page.basePlan.badgeText"
                [features]="page.basePlan.features"
                [ctaText]="upgradeButtonLabel"
                secondaryCtaText="Learn more"
                [disabled]="loading || areTheInitialRegistrationStepsIncomplete()"
                (selectPlan)="select(pricingPlans.identibasePlus)"
                (secondaryAction)="navigateToProductPage(PricingTableSubTypes.IDENTIBASEPLUS)"
              ></app-plan-card>

              <!-- Alert -->
              <app-plan-card
                *ngIf="identiAlertAvailable"
                class="col order-2"
                variant="alert"
                [showStripe]="false"
                [title]="page.alertPlan.title"
                [price]="plan2YearlyPrice"
                [monthlyPrice]="plan2MonthlyPrice"
                [badgeText]="page.alertPlan.badgeText"
                [features]="page.alertPlan.features"
                [ctaText]="upgradeButtonLabel"
                secondaryCtaText="Learn more"
                [disabled]="loading || areTheInitialRegistrationStepsIncomplete()"
                (selectPlan)="selectAlert()"
                (secondaryAction)="navigateToProductPage(PricingTableSubTypes.IDENTIALERT)"
              ></app-plan-card>

              <!-- Locator -->
              <app-plan-card
                *ngIf="isIdentiSmartTagPlanAvailable && smartTagSubAvailable"
                class="col order-1 order-lg-3"
                variant="locator"
                [showStripe]="false"
                [title]="page.locatorPlan.title"
                [price]="plan3YearlyPrice"
                [originalPrice]="plan3YearlyPriceOriginal"
                [badgeText]="page.locatorPlan.badgeText"
                [iconSrc]="page.locatorPlan.iconSrc"
                [colorOptions]="page.locatorPlan.colorOptions"
                [features]="page.locatorPlan.features"
                [ctaText]="upgradeButtonLabel"
                secondaryCtaText="Learn more"
                [disabled]="loading || areTheInitialRegistrationStepsIncomplete()"
                (selectPlan)="select(pricingPlans.smartTagSubscription)"
                (secondaryAction)="navigateToProductPage(PricingTableSubTypes.SMARTTAG)"
              ></app-plan-card>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-template #legacyPricingTable>
        <div class="container">
          <div class="row mb-3 mt-2">
            <div class="col-12">
              <app-pricing-table
                [hidePrices]="false"
                [showInfoLine]="true"
                [disabled]="loading || areTheInitialRegistrationStepsIncomplete()"
                [pricingPlans]="pricingPlans"
                [user]="user"
                [showShortDescriptionList]="true"
                [buttonLabel]="showUpgradeNowButton ? 'Upgrade now' : 'Buy now'"
                [availableProductIds]="availableProductIds"
                (onSelect)="select($event)"
                (onNavigateToProductPage)="navigateToProductPage($event)"
                [isDashboard]="true"
              />
            </div>
          </div>
        </div>
      </ng-template>

      <div class="row">
        <div class="col-12">
          <ngb-alert
            *ngIf="alert"
            class="sticky-top my-3"
            (closed)="closeAlert()"
            style="top: 10px"
            [type]="alert.type"
          >
            {{ alert.message }}
          </ngb-alert>

          <ngb-alert
            *ngIf="incompletePetRegistations.length"
            class="my-3"
            [dismissible]="false"
            [type]="'warning'"
          >
            <div class="row">
              <div class="col-12 col-md-8">
                <p class="mb-2 mb-md-0">
                  <strong>Complete your registration</strong>
                  <br />
                  You haven't finished registering your
                  {{ incompletePetRegistations.length > 1 ? 'pets' : 'pet' }}
                  yet!
                  <br />
                </p>
              </div>
              <div
                class="col-12 col-md-4 text-center text-md-end d-flex flex-row justify-content-center justify-content-md-end align-items-center"
              >
                <button
                  class="btn btn-secondary text-white mt-1"
                  [disabled]="areTheInitialRegistrationStepsIncomplete()"
                  [routerLink]="
                    incompletePetRegistations.length > 1
                      ? '/my-pets'
                      : ['/my-pet', incompletePetRegistations[0].id, 'confirm']
                  "
                >
                  <p class="mb-0">
                    <strong>Complete</strong>
                  </p>
                </button>
              </div>
            </div>
          </ngb-alert>

          <ngb-alert
            *ngFor="let pet of missingPetsWithNoReport"
            [dismissible]="false"
            [type]="'info'"
            class="my-3"
          >
            <h4 class="alert-heading">
              {{ pet.name }} is
              {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}.
            </h4>
            <div class="row">
              <div class="col-12">
                <p>
                  Someone has reported your pet as missing. Please
                  <a class="alert-link" [routerLink]="['/my-pet', pet.id, 'report-missing']">
                    create your missing pet report here
                  </a>
                  so we can help find {{ pet.name }}.
                </p>
              </div>
            </div>
          </ngb-alert>
        </div>
      </div>
    </div>
  </div>

  <ng-container *appFeatureFlag="'isPerkListAvailable'">
    <div *ngIf="perks.length" class="container mb-4">
      <ngb-alert
        [dismissible]="false"
        type="info"
        class="my-3"
      >
        <div class="row">
          <div class="col-12">
            <h6 class="my-1 text-primary"><b>Don't miss your pet perks!</b></h6>
            <span *ngIf="showSecondLineInThePerkInfoText"> From food, pet care and insurance to training, treats and toys, we've got big savings for our identi pet parents.</span>
          </div>
        </div>
      </ngb-alert>
    </div>
  </ng-container>

  <div
    *appFeatureFlag="'isPerkListAvailable'"
    id="offerListHeader"
    class="pt-2 pb-3"
    [ngClass]="perks?.length === 0 ? 'd-none' : ''"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div *ngIf="perks.length" class="row d-flex justify-content-between align-items-stretch">
            <div class="col-12 mb-3 perk-wrapper" [ngClass]="{ 'perk-preview': previewPremium }">
              <div class="row">
                <div
                  *ngFor="let perk of perks; let perkIndex = index"
                  class="col-12 d-inline-flex"
                  [ngClass]="{
                    'large-col': perk.widget.widgetSize == WidgetSize.Large,
                    'mid-col':
                      perk.widget.widgetSize !== WidgetSize.Large &&
                      perk.widget.widgetSize !== WidgetSize.Small,
                    'small-col': perk.widget.widgetSize == WidgetSize.Small,
                  }"
                >
                  <app-perk-widget
                    class="mb-4"
                    [enabled]="
                      (!perk.disabled && !areTheInitialRegistrationStepsIncomplete()) ||
                      perk.widget.redirectUri === 'welcome-gift'
                    "
                    [disabledText]="'Complete the registration flow to access the offer'"
                    [widgetSize]="perk.widget.widgetSize ? perk.widget.widgetSize : WidgetSize.Medium"
                    [perk]="perk"
                    [totalNumberOfPerks]="perks.length"
                    [currentPerkNumber]="perkIndex + 1"
                    [preview]="previewPremium"
                    (lastPerkRendered)="onLastPerkRendered()"
                  ></app-perk-widget>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
